import instance from './DefaultApi';

export default class SAPDataReportService {
    ControllerName = 'SAPMaster';

    // get all data of Feedback Report
    GetSAPDataReport(tableRequest) {
        return instance.get(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetSAPDataReport`).then(res => res)
    }
}